import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }
`;

const STATE = {
  isOpenAddModal: false,
  remarks: [],
  additionalRemarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class KanbanRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.vehicle?.[this.props.remarksType] &&
      this.setState({ remarks: JSON.parse(this.props.vehicle?.[this.props.remarksType]) });
    this.props.vehicle?.[this.props.additionalRemarksType] &&
      this.setState({ additionalRemarks: JSON.parse(this.props.vehicle?.[this.props.additionalRemarksType]) });
  }

  renderInitials(name, surname, boardLabel) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
        &nbsp;
        <strong>{`- ${boardLabel} board` ?? ''}</strong>
      </HBox>
    );
  }

  reset() {
    this.setState({ isOpenAddModal: false, newRemarkText: '', editableRemark: null });
  }

  render() {
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };
    return (
      <Card className="vehicle-info-card info-card data">
        <Container>
          <HBox>
            <h2>{this.lbl('info.kanban_remarks.title')}</h2>
          </HBox>
          <br />
          <List>
            {[
  ...(Array.isArray(this.state.remarks) ? this.state.remarks : []),
  ...(Array.isArray(this.state.additionalRemarks) ? this.state.additionalRemarks : []),
].map(remark => (
                <Row key={remark?.text}>
                  <VBox className="remark" vCenter>
                    {remark?.name &&
                      remark?.surname &&
                      this.renderInitials(remark?.name, remark?.surname, remark?.kanbanBoardLabel)}
                    <p className="text" dangerouslySetInnerHTML={nl2br(remark?.text)}></p>
                  </VBox>
                  <HBox right>{remark?.date}</HBox>
                </Row>
              ))}
          </List>
        </Container>
      </Card>
    );
  }
}

KanbanRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanRemarksCard = compose(withConnect, withRouter)(KanbanRemarksCardComp);
